export const GET_RANDOM_MEAL_SUCCESS = "GET_RANDOM_MEAL_SUCCESS";
export const GET_RANDOM_MEAL_FAIL = "GET_RANDOM_MEAL_FAIL";
export const GET_RECIPE_SUCCESS = "GET_RECIPE_SUCCESS";
export const GET_RECIPE_FAIL = "GET_RECIPE_FAIL";
export const GET_FORM_MEAL_SUCCESS = "GET_FORM_MEAL_SUCCESS";
export const GET_FORM_MEAL_FAIL = "GET_FORM_MEAL_FAIL";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const GET_LIST_SUCCESS = "GET_LIST_SUCCESS";
export const GET_LIST_FAIL = "GET_LIST_FAIL";
export const POST_LIST_SUCCESS = "POST_LIST_SUCCESS";
export const POST_LIST_FAIL = "POST_LIST_FAIL";
export const LOGOUT = "LOGOUT";